import { Injectable, inject } from "@angular/core";
import { OrderModel } from "../models/order.model";
import { environment } from "src/environments/environment";
import { HomePageService } from "src/app/Customer/services/home-page.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { CommonService } from "src/app/Shared/services/common.service";
import { Subject, takeUntil } from "rxjs";
import { PostAnswer } from "../models/postQueryAnswer.model";

@Injectable({
  providedIn: "root",
})
export class OrderActivityService {
  private homePageService = inject(HomePageService);
  private http = inject(HttpClient);
  private commonService = inject(CommonService);

  apiUrl = environment.apiUrl;
  private selectedOrder: OrderModel;
  onDestroy$ = new Subject<boolean>();
  private state: {
    selectedStatus: string;
    pageNumber: number;
    pageSize: number;
    startDate: any;
    endDate: any;
  };

  setState(state) {
    this.state = { ...state };
  }

  getState() {
    //we don't directly return the state because we don't want the reference to be modified outside the service
    return this.state ? { ...this.state } : undefined;
  }

  resetState() {
    this.state = undefined;
  }

  getSelectedOrder(): OrderModel {
    return this.selectedOrder;
  }

  setSelectedOrder(order: OrderModel) {
    this.selectedOrder = order;
  }

  //Fetching orders of a vendor from a specific page of a specific size. The response should also contain a field for totalOrders
  fetchVendorOrders(
    pageNumber: number,
    pageSize: number,
    selectedStatus: string,
    startDate?: string,
    endDate?: string,
    searchString?: string,
    selectedOption?: string,
    selectedFilter?: string
  ) {
    let params = new HttpParams({
      fromObject: {
        pageNumber: pageNumber.toString(),
        pageSize: pageSize.toString(),
        status: selectedStatus,
      },
    });
    if (startDate) {
      params = params.set("startDate", startDate);
    }

    if (endDate) {
      params = params.set("endDate", endDate);
    }

    if (searchString && searchString.trim().length > 0) {
      params = params.set("searchString", searchString.trim());
    }
    if (selectedOption) {
      params = params.set("sortBy", selectedOption);
    }
    if (selectedFilter) {
      params = params.set("sortOrderColumn", selectedFilter);
    }
    return this.http.get(`${this.apiUrl}Vendor/OrderHistory`, { params });
  }

  //Fetches a single vendor order based on its ID
  fetchVendorOrder(orderId: number) {
    const siteId = this.homePageService.configurations.site;
    let params = new HttpParams({
      fromObject: {
        // vendor: vendorId,
        webOrder: orderId,
        // site:siteId
      },
    });
    return this.http.get(`${this.apiUrl}Vendor/WebOrder`, { params: params });
  }

  //updates the order by changing the status of specified items.
  updateOrder(
    data: { webOrderDetail: number; orderState: string; addedOn: Date }[]
  ) {
    return this.http.put(`${this.apiUrl}Vendor/WebOrder/State`, data);
  }

  //adds a vendor answer for a paricular question of a particular item of a particular order
  addAnswerToOrderItem(FAQ: PostAnswer, answer: string) {
    FAQ.answerX = answer;
    return this.http.put(`${this.apiUrl}Vendor/WebOrder/FAQ`, {
      ...FAQ,
      isQuestionUpdated: false,
    });
  }

  //possible order statuses
  fetchOrderStatuses() {
    //dummy data
    // 'PaymentPending': 'Payment pending',
    // 'Processing': 'Processing',
    //
    // 'PendingQuery': 'Pending queries'
    // 'Cancelled': 'Cancelled',
    return {
      All: "All",
      Submitted: "Submitted",
      Shipped: "Shipped",
      Delivered: "Delivered",
      OFD: "OFD",
    };
  }
  fetchOrderActivityStatus(): { key: string; value: boolean; count: number }[] {
    return [
      { key: "Published", value: false, count: 0 },
      { key: "Draft", value: false, count: 0 },
      { key: "New", value: false, count: 0 },
      { key: "Reviewing", value: false, count: 0 },
      { key: "Approved", value: false, count: 0 },
      { key: "Rejected", value: false, count: 0 },
      { key: "UnPublished", value: false, count: 0 },
      { key: "Blocked", value: false, count: 0 },
    ];
  }
  //possible order-item statuses
  fetchOrderItemStatuses() {
    // 'Processing': 'Processing',
    //dummy data
    return {
      Shipped: "Shipped",
    };
  }

  //fetches status chnage history for a particular item of an order
  fetchOrderItemStatusChangeHistory(itemId: number) {
    let params = new HttpParams();
    params = params.set("webOrderDetail", itemId);
    return this.http.get(`${this.apiUrl}Vendor/WebOrderDetail/State`, {
      params: params,
    });
  }

  acceptOrRejectReturn(model) {
    return this.http.post(
      `${this.apiUrl}Vendor/AcceptReturnOrReplacement`,
      model
    );
  }
  FetchWebOrderShippingStatus(webOrderDetail) {
    return this.http.get(
      `${this.apiUrl}WebOrder/FetchWebOrderShippingStatus?webOrderDetail=${webOrderDetail}`
    );
  }
  // changeDummyStatusFastBeetle(model){
  //   return this.http.post("http://localhost:4200/fastBeetle?fastBeetleApis=https://dev.fastbeetle.com/merchant/v1/merchantApi/updateOrder", {model});
  // }
  ngOnDestroy(): void {
    this.onDestroy$.complete();
  }
  objectToString(properties) {
    const prop = JSON.parse(properties);
    const pairs = [];
    for (const key in prop) {
      if (prop.hasOwnProperty(key)) {
        pairs.push(`${key}: ${prop[key]}`);
      }
    }
    return pairs.join(", ");
  }
  fetchRefundStatus(refundId) {
    return this.http.get(
      `${this.apiUrl}Payment/FetchRefundById?refundId=${refundId}`
    );
  }
  fetchCatalogItemCount(model: any) {
    return this.http.get(`${this.apiUrl}Vendor/FetchCatalogItemCount`, { params: model })
  }

  ConversationSeen(model) {
    return this.http.post(
      `${this.apiUrl}WebOrder/ConversationSeen`,
      model
    );
  }
  fetchConversionInactive() {
    return this.http.get(`${this.apiUrl}WebOrder/CatalogItemConversationFetch`)
  }
  fetchUnAnsweredQuestions(model) {
    return this.http.get(`${this.apiUrl}Vendor/UnseenQueries`, { params: model })
  }

}
